import api from "@/Library/api.js";

export default {

    GET_SYSTEM_PHOTO_CATE_LIST(data) {
        return api({ url: "/Photo/SystemPhotoCateList", method: "post", data: data });
    },

    GET_SYSTEM_PHOTO_CATE_LIST_FOR_CASCADE(data) {
        return api({ url: "/Photo/SystemPhotoCateListForCascade", method: "post", data: data });
    },

    ADD_SYSTEM_PHOTO_CATE(data) {
        return api({ url: "/Photo/SystemPhotoCateAdd", method: "post", data: data });
    },

    CHANGE_SYSTEM_PHOTO_CATE_NAME(data) {
        return api({ url: "/Photo/SystemPhotoCateNameChange", method: "post", data: data });
    },

    SORT_SYSTEM_PHOTO_CATE(data) {
        return api({ url: "/Photo/SystemPhotoCateSort", method: "post", data: data });
    },

    DEL_SYSTEM_PHOTO_CATE(data) {
        return api({ url: "/Photo/SystemPhotoCateDel", method: "post", data: data });
    },

    ADD_SYSTEM_PHOTO(data) {
        return api({ url: "/Photo/SystemPhotoAdd", method: "post", data: data });
    },

    CHANGE_SYSTEM_PHOTO_NAME(data) {
        return api({ url: "/Photo/SystemPhotoNameChange", method: "post", data: data });
    },

    DEL_SYSTEM_PHOTO(data) {
        return api({ url: "/Photo/SystemPhotoDel", method: "post", data: data });
    },

    GET_SYSTEM_PHOTO_LIST(data) {
        return api({ url: "/Photo/SystemPhotoList", method: "post", data: data });
    },

}
